import { SxProps } from "@mui/material";

export const sxButton: SxProps = {
  fontFamily: 'Unimed-Sans',
  borderRadius: '80px',
  padding: '12px 32px ',

  '@media (max-width: 899px)': {
    width: '100%',
    maxWidth: 'unset'
  },
}

export const sxButtonAccessibility: SxProps = {
  ...sxButton,
  borderColor: '#FFFF00',
  color: '#FFFF00'
}

export const sxButtonText: SxProps = {
  textTransform: 'none',
  textDecoration: 'underline',
  width: '100vw',
  height: '100%',
  maxWidth: '135px',
  textAlign: 'start',
}

export const sxButtonTextAccessibility: SxProps = {
  ...sxButtonText,
  color: '#FFFF00'
}

export const sxButtonLabel: SxProps = {
    fontFamily: 'Unimed-Sans', 
    maxWidth: '100%',
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap', 
    display: 'block', 
    textAlign: 'start',
    fontSize: '14px',
    fontWeight: 400,
    textWrap: 'wrap',
    color: '#00995D'
}